// AIDEV-NOTE: portal-preferences; localStorage-based portal preference persistence

const PORTAL_PREFERENCE_KEY = 'salsa-portal-preference'

type PortalType = 'account' | 'manager' | 'admin'

/**
 * Get the last portal used by the user
 * @returns The last portal type, or null if not set or invalid
 */
export function getLastPortal(): PortalType | null {
  try {
    const stored = localStorage.getItem(PORTAL_PREFERENCE_KEY)
    if (stored && ['account', 'manager', 'admin'].includes(stored)) {
      return stored as PortalType
    }
    return null
  } catch {
    // localStorage might be unavailable (private browsing, etc.)
    return null
  }
}

/**
 * Save the user's portal preference
 * @param portal - The portal type to save
 */
export function setLastPortal(portal: PortalType): void {
  try {
    localStorage.setItem(PORTAL_PREFERENCE_KEY, portal)
  } catch {
    // Ignore localStorage errors (private browsing, quota exceeded, etc.)
    console.warn('Failed to save portal preference to localStorage')
  }
}

/**
 * Clear the stored portal preference
 */
export function clearLastPortal(): void {
  try {
    localStorage.removeItem(PORTAL_PREFERENCE_KEY)
  } catch {
    // Ignore localStorage errors
  }
}
